import React from "react";
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  EditButton,
  TextInput,
  SelectInput,
  TopToolbar,
  FilterButton,
  CreateButton,
} from "react-admin";
import Chip from "@material-ui/core/Chip";
import { getTagLabel } from "./util";

const trainingVideoFilters = [
  <TextInput key="title" label="Name" source="title" alwaysOn={false} />,
  <SelectInput
    key="active"
    label="Active"
    source="active"
    choices={[
      { name: "Active", value: 1 },
      { name: "Inactive", value: 0 },
    ]}
    optionValue="value"
    alwaysOn={false}
  />,
];

const TrainingVideoListActions = ({ filters }) => (
  <TopToolbar>
    <FilterButton filters={filters} />
    <CreateButton />
  </TopToolbar>
);

const TagsField = ({ record }) => {
  const tags = record && Array.isArray(record.tags) ? record.tags : [];
  return (
    <span>
      {tags.map((tag, index) => (
        <Chip
          key={getTagLabel(tag) || index}
          label={getTagLabel(tag)}
          size="small"
          style={{ margin: 2 }}
        />
      ))}
    </span>
  );
};
TagsField.defaultProps = { label: "Tags", sortable: false };

const TrainingVideoList = props => (
  <List
    {...props}
    exporter={false}
    bulkActionButtons={false}
    filters={trainingVideoFilters}
    actions={<TrainingVideoListActions filters={trainingVideoFilters} />}
  >
    <Datagrid rowClick="edit">
      <TextField source="title" label="Title" />
      <NumberField source="priority" label="Priority" />
      <BooleanField source="active" label="Active" sortable={false} />
      <TagsField source="tags" />
      <EditButton />
    </Datagrid>
  </List>
);

export default TrainingVideoList;
